import React from 'react';
import {
	PLATE_ART_TINTS,
	plateArtAssetUrl,
	plateArtClipId,
	plateArtPatternId,
	plateArtStroke,
} from '../lib/plateArtMap';

/**
 * One SVG pattern per seen state. The image is scaled uniformly to cover the
 * state's bounding box, then the geography path clips it to the outline.
 */
export default function PlateArtPatternDefs({ entries }) {
	if (!entries?.length) return null;
	return (
		<defs>
			{entries.map(({ stateId, tint }) => {
				const overlay = PLATE_ART_TINTS[tint];
				return (
					<pattern
						key={`${stateId}-${tint}`}
						id={plateArtPatternId(stateId, tint)}
						patternUnits="objectBoundingBox"
						patternContentUnits="objectBoundingBox"
						width="1"
						height="1"
						pointerEvents="none"
						style={{ pointerEvents: 'none' }}
					>
						<image
							href={plateArtAssetUrl(stateId)}
							x="0"
							y="0"
							width="1"
							height="1"
							preserveAspectRatio="xMidYMid slice"
							pointerEvents="none"
							style={{ pointerEvents: 'none' }}
						/>
						{overlay ? (
							<rect width="1" height="1" fill={overlay.color} fillOpacity={overlay.opacity} />
						) : null}
					</pattern>
				);
			})}
		</defs>
	);
}

/**
 * Thick orange or green outline drawn inside each seen state, on top of the plate.
 * Clipped so the stroke stays inside that state and does not cover a neighbor.
 */
export function PlateArtInnerBorders({ entries }) {
	if (!entries?.length) return null;
	return (
		<>
			<defs>
				{entries.map(({ stateId, svgPath }) => (
					<clipPath id={plateArtClipId(stateId)} key={stateId} clipPathUnits="userSpaceOnUse">
						<path d={svgPath} />
					</clipPath>
				))}
			</defs>
			{entries.map(({ stateId, tint, svgPath }) => {
				const stroke = plateArtStroke(tint, svgPath);
				if (!stroke) return null;
				return (
					<path
						key={`plate-border-${stateId}`}
						d={svgPath}
						fill="none"
						stroke={stroke.color}
						strokeWidth={stroke.width}
						strokeLinejoin="round"
						clipPath={`url(#${plateArtClipId(stateId)})`}
						pointerEvents="none"
						style={{ pointerEvents: 'none' }}
					/>
				);
			})}
		</>
	);
}
